/**
 * Monitors elements and executes a callback when they enter view.
 * @param {string} selector - The CSS selector for elements to watch.
 * @param {function} callback - The code to run (receives the element as an argument).
 */

// Animated wave start
// Get all containers and their respective paths
var waveContainers = document.querySelectorAll('#canvas-container');

// Only run if elements exist
if (waveContainers.length > 0) {
  var wavesData = [];

  // Initialize data for each wave found
  waveContainers.forEach(function (container) {
    var wavePath = container.querySelector('#animated-wave');
    if (wavePath) {
      wavesData.push({
        container: container,
        path: wavePath,
        width: 0,
        height: 0,
        waveHeight: 0,
        waveDelta: 0,
        wavePoints: 0,
        speed: 0.3
      });
    }
  });

  /**
   * Updates dimensions for every wave instance
   */
  function updateAllDimensions() {
    wavesData.forEach(function (item) {
      item.width = item.container.offsetWidth;
      item.height = item.container.offsetHeight;

      if (window.innerWidth < 750) {
        item.waveHeight = 10;
        item.waveDelta = 16;
        item.wavePoints = 5;
      } else {
        item.waveHeight = 26;
        item.waveDelta = 30;
        item.wavePoints = 8;
      }
    });
  }

  function calculateWavePoints(factor, waveObj) {
    var points = [];
    for (var i = 0; i <= waveObj.wavePoints; i++) {
      var x = i / waveObj.wavePoints * waveObj.width;
      var sinSeed = (factor + (i + i % waveObj.wavePoints)) * waveObj.speed * 100;
      var sinHeight = Math.sin(sinSeed / 100) * waveObj.waveDelta;
      var yPos = Math.sin(sinSeed / 100) * sinHeight + waveObj.waveHeight;
      points.push({ x: x, y: yPos });
    }
    return points;
  }

  function buildPath(points, waveObj) {
    var SVGString = 'M ' + points[0].x + ' ' + points[0].y;

    var cp0 = {
      x: (points[1].x - points[0].x) / 2,
      y: (points[1].y - points[0].y) + points[0].y + (points[1].y - points[0].y)
    };
    SVGString += ' C ' + cp0.x + ' ' + cp0.y + ' ' + cp0.x + ' ' + cp0.y + ' ' + points[1].x + ' ' + points[1].y;

    var prevCp = cp0;
    for (var i = 1; i < points.length - 1; i++) {
      var cp1 = {
        x: (points[i].x - prevCp.x) + points[i].x,
        y: (points[i].y - prevCp.y) + points[i].y
      };
      SVGString += ' C ' + cp1.x + ' ' + cp1.y + ' ' + cp1.x + ' ' + cp1.y + ' ' + points[i + 1].x + ' ' + points[i + 1].y;
      prevCp = cp1;
    }

    SVGString += ' L ' + waveObj.width + ' ' + waveObj.height;
    SVGString += ' L 0 ' + waveObj.height + ' Z';
    return SVGString;
  }

  var lastUpdate;
  var totalTime = 0;

  function tick() {
    var now = window.Date.now();
    if (lastUpdate) {
      var elapsed = (now - lastUpdate) / 1000;
      lastUpdate = now;
      totalTime += elapsed;
      var factor = totalTime * Math.PI;

      // Update every wave in the array
      wavesData.forEach(function (waveObj) {
        var points = calculateWavePoints(factor, waveObj);
        waveObj.path.setAttribute('d', buildPath(points, waveObj));
      });
    } else {
      lastUpdate = now;
    }
    window.requestAnimationFrame(tick);
  }

  // Initial call and event listener
  updateAllDimensions();
  window.addEventListener('resize', updateAllDimensions);
  tick();
}
// Animated wave end

function onEnterViewport(selector, callback) {
  const options = {
    threshold: 0.4 // Triggers when 10% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // CALL YOUR CUSTOM CODE HERE
        callback(entry.target);

        // Optional: stop watching after it runs once
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // Start watching all elements that match your selector
  document.querySelectorAll(selector).forEach(el => observer.observe(el));
}

onEnterViewport('.home-the-kappo-difference', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.home-testimonials', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.footer1', (element) => {
  element.querySelector('.footer-menu').classList.add('in-view');
  element.querySelector('.links-container ').classList.add('in-view');
  element.querySelector('.footer-image').classList.add('in-view');
  element.querySelectorAll('.fadeIn-from-bottom').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.find-kappo-near-you-section', (element) => {
  element.querySelector('.find-kappo-near-you-box').classList.add('in-view');
});

onEnterViewport('.home-page-form', (element) => {
  element.querySelector('.home-form').classList.add('in-view');
  element.querySelector('.home-contacts').classList.add('in-view');
  element.querySelector('.section9-text-bg').classList.add('in-view');
  element.querySelector('.home-contact-text').classList.add('in-view');
});

onEnterViewport('.every-crunch-desktop', (element) => {
  element.querySelectorAll('.scale-text').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.every-crunch-mask').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.every-crunch', (element) => {
  element.querySelectorAll('.scale-text').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.every-crunch-mask').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.every-crunch-bg1').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.every-crunch-card').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.tag-us-row', (element) => {
  element.querySelectorAll('.card').forEach(el => el.classList.add('in-view'));
});

window.addEventListener('load', () => {
  document.querySelector('.kappo-header').classList.add('in-view');
});

window.addEventListener('load', () => {
  document.querySelector('.bannerScaleFadeText').classList.add('in-view');
  document.querySelector('.kappo-banner__bg').classList.add('in-view');
  //document.querySelector('.kappo-header').classList.add('in-view');
  document.querySelector('.banner-package-1').classList.add('in-view');
  document.querySelector('.banner-package-2').classList.add('in-view');
  document.querySelector('.banner-package-3').classList.add('in-view');
  document.querySelector('.banner-package-4').classList.add('in-view');
  document.querySelector('.banner-package-5').classList.add('in-view');
  document.querySelector('.banner-package-6').classList.add('in-view');
  document.querySelector('.banner-package-7').classList.add('in-view');
  document.querySelector('.banner-package-8').classList.add('in-view');
  document.querySelector('.banner-package-9').classList.add('in-view');
  document.querySelector('.banner-package-10').classList.add('in-view');
  document.querySelector('.banner-package-11').classList.add('in-view');
  document.querySelector('.banner-package-12').classList.add('in-view');
  document.querySelector('.banner-package-13').classList.add('in-view');
});

onEnterViewport('.home-onam-girl-section', (element) => {
  element.querySelectorAll('.onam-girl-bg').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.onam-girl').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.onam-girl-text').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.infinite-rotating-image').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.bg-vector').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.section5-btn').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.womens-chips-down').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.enter-from-right').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.enter-from-left').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.shake-text-section', (element) => {
  element.querySelectorAll('.section-7').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.section4-banner', (element) => {
  element.querySelectorAll('.content-image').forEach(el => el.classList.add('in-view'));
});

//ABOUT
onEnterViewport('.about-us-the-kappo-difference', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.about-our-story', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.section-3', (element) => {
  element.querySelectorAll('.scale-text').forEach(el => el.classList.add('in-view'));
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.collapsible-content', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.product-grid-container', (element) => {
  element.querySelector('.fadeIn-from-bottom').classList.add('in-view');
});

onEnterViewport('.about-us-mobile-text-row', (element) => {
  element.querySelectorAll('.fadeIn-from-bottom').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.abost-section-3', (element) => {
  element.querySelectorAll('.scale-text').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.join-the-movement', (element) => {
  element.querySelector('.home-contacts').classList.add('in-view');
  element.querySelector('.hand-image').classList.add('in-view');
  element.querySelector('.banner-package-9').classList.add('in-view');
});

onEnterViewport('.contact-split', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.home-contacts').classList.add('in-view');
  element.querySelector('.section9-text-bg').classList.add('in-view');
  element.querySelectorAll('.banner-package-9').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.mobile-contact-split', (element) => {
  element.querySelector('.scale-text').classList.add('in-view');
  element.querySelector('.home-contacts').classList.add('in-view');
  element.querySelector('.section9-text-bg').classList.add('in-view');
  element.querySelectorAll('.banner-package-9').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.custom-contact-form__container', (element) => {
  element.querySelector('.section9-text-bg').classList.add('in-view');
  element.querySelector('.home-form').classList.add('in-view');
});

onEnterViewport('.about-us-page', (element) => {
  element.querySelectorAll('.scale-text').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.banner-package-4').forEach(el => el.classList.add('in-view'));
  element.querySelectorAll('.banner-package-9').forEach(el => el.classList.add('in-view'));
});

onEnterViewport('.mobile-about-us-page', (element) => {
  element.querySelector('.banner-package-9').classList.add('in-view');
});